import { NotificationProps } from "shared/services/api/notificacoes.api";

export const traduzirTopic = (topic: NotificationProps["topic"]) => {
  switch (topic) {
    case "ORDER_CREATED":
      return "Pedido criado";
    case "ORDER_PAID":
      return "Pagamento aprovado";
    case "ORDER_SHIPPED":
      return "Pedido enviado";
    case "ORDER_DELIVERED":
      return "Pedido entregue";
    case "ORDER_CANCELLED":
      return "Pedido cancelado";
    case "PROMOTION":
      return "Promoção";
    case "SALE":
      return "Venda";
    case "PURCHASE":
      return "Compra";
    case "SYSTEM":
      return "Sistema";
    default:
      return "Notificação";
  }
};

export const traduzirRecipientType = (recipientType: string) => {
  switch (recipientType) {
    case "BUYER":
      return "Comprador";
    case "STORE_OWNER":
      return "Loja";
    default:
      return recipientType;
  }
};

export const traduzirReferenceType = (type: string) => {
  switch (type) {
    case "ORDER":
      return "Pedido";
    case "PRODUCT":
      return "Produto";
    case "STORE":
      return "Loja";
    default:
      return type;
  }
};